import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LoginForm } from '@/components/auth/login-form'
import { useAuthStore } from '@/stores/auth-store'

export default function LoginPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { isAuthenticated } = useAuthStore()
  const emailConfirmed = searchParams.get('confirmed') === '1'

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true })
    }
  }, [isAuthenticated, navigate])

  const handleLoginSuccess = () => {
    navigate('/', { replace: true })
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-orange-500 mb-2">
            KookInspiratie
          </h1>
          <p className="text-gray-600">
            Jullie weekmenu en recepten op één plek
          </p>
        </div>

        {emailConfirmed ? (
          <div className="rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-800">
            Je e-mailadres is bevestigd. Log in om verder te gaan.
          </div>
        ) : null}
        
        <LoginForm onSuccess={handleLoginSuccess} />
      </div>
    </div>
  )
}
